import { useUpdateEmployeeAdditionalNotes } from "@/generated/people/people";
import {
  useProfileSectionForm,
  useProfileSectionSave,
} from "@/hooks/use-profile-section-form";
import {
  additionalNotesFormValues,
  additionalNotesRequest,
  additionalNotesSchema,
} from "@/lib/people-profile-sections";

import { ProfileSectionForm } from "../ProfileSectionForm";
import { SectionTextArea } from "./ProfileSectionFields";

interface EditAdditionalNotesFormProps {
  nurseryId: string;
  userId: string;
  additionalNotes: string | null;
  onDone: () => void;
}

export function EditAdditionalNotesForm({
  nurseryId,
  userId,
  additionalNotes,
  onDone,
}: EditAdditionalNotesFormProps) {
  const { values, setErrors, setField, errors, validate } =
    useProfileSectionForm(
      () => additionalNotesFormValues(additionalNotes),
      additionalNotesSchema,
    );
  const update = useUpdateEmployeeAdditionalNotes({
    mutation: useProfileSectionSave(
      nurseryId,
      userId,
      "Additional notes",
      onDone,
      setErrors,
    ),
  });
  const isPending = update.isPending;

  const handleSubmit = () => {
    if (!validate()) return;
    update.mutate({ nurseryId, userId, data: additionalNotesRequest(values) });
  };

  return (
    <ProfileSectionForm
      testId="edit-additional-notes-form"
      onCancel={onDone}
      isPending={isPending}
      onSubmit={handleSubmit}
    >
      <SectionTextArea
        label="Notes"
        name="additionalNotes"
        value={values.additionalNotes}
        onChange={(value) => setField("additionalNotes", value)}
        disabled={isPending}
        error={errors.additionalNotes}
      />
    </ProfileSectionForm>
  );
}
